import React, { useState } from 'react';
interface RemoveEntryButtonProps {
  bookingReference: string;
  onRemoveEntry: Function;
}

const RemoveEntryButton : React.FC<RemoveEntryButtonProps> = ({ bookingReference, onRemoveEntry }) => {


  return (
    <button
      data-testid="booking-remove-button"
      className={`bg-gray-300 hover:bg-red-500 hover:text-white font-bold py-1 px-2 rounded disabled:bg-gray-200 disabled:text-gray-400`}
      onClick={() => onRemoveEntry(bookingReference)}
    >Remove</button>
  );
};

export default RemoveEntryButton;
